import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendIntraAccount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 186,
	height: 186,
	viewBox: "0 0 186 186",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_4918_27537)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 93,
				cy: 88,
				r: 63,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.1738 73.7256C75.1738 70.4119 77.8601 67.7256 81.1738 67.7256H105.274C108.588 67.7256 111.274 70.4119 111.274 73.7256V92.1256C111.274 95.4393 108.588 98.1256 105.274 98.1256H81.1738C77.8601 98.1256 75.1738 95.4393 75.1738 92.1256V73.7256Z",
			fill: "#F09337"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 67.5742,
			y: 73.3252,
			width: 38.1,
			height: 32.4,
			rx: 7,
			fill: "#FFCE32",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 68.5742,
			y: 74.3252,
			width: 36.1,
			height: 30.4,
			rx: 6,
			fill: "url(#paint0_linear_4918_27537)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.4448 89.1132C82.3904 89.1132 83.9677 87.536 83.9677 85.5903C83.9677 83.6446 82.3904 82.0674 80.4448 82.0674C78.4991 82.0674 76.9219 83.6446 76.9219 85.5903C76.9219 87.536 78.4991 89.1132 80.4448 89.1132Z",
			fill: "#1E63FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.08 98.2734H74.8066C74.8066 94.7505 76.3271 91.2275 80.4433 91.2275C84.5595 91.2275 86.08 94.7505 86.08 98.2734Z",
			fill: "#1E63FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.6831 99.7736H98.1831V98.2736C98.1831 96.0664 97.712 93.7121 96.4591 91.8619C95.1548 89.9359 93.0718 88.6709 90.2009 88.6709C87.3301 88.6709 85.247 89.9359 83.9427 91.8619C82.6898 93.7121 82.2188 96.0664 82.2188 98.2736V99.7736H83.7188H96.6831Z",
			fill: "#1E63FF",
			stroke: "url(#paint1_linear_4918_27537)",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.1998 87.7404C92.4373 87.7404 94.2511 85.9266 94.2511 83.6891C94.2511 81.4515 92.4373 79.6377 90.1998 79.6377C87.9623 79.6377 86.1484 81.4515 86.1484 83.6891C86.1484 85.9266 87.9623 87.7404 90.1998 87.7404Z",
			fill: "#1E63FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.924 93.2256C101.849 93.2256 96.9238 98.1506 96.9238 104.226C96.9238 110.301 101.849 115.226 107.924 115.226C113.999 115.226 118.924 110.301 118.924 104.226C118.924 98.1506 113.999 93.2256 107.924 93.2256Z",
			fill: "#FFCE32",
			stroke: "white",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.827 107.974L110.453 107.974L110.453 105.785L104.827 105.785L104.827 104.033L101.761 106.88L104.827 109.726L104.827 107.974Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.234 100.477L105.607 100.477L105.607 102.666L111.234 102.666L111.234 104.418L114.299 101.572L111.234 98.7251L111.234 100.477Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_4918_27537",
				x: 0,
				y: 0,
				width: 186,
				height: 186,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 5 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 15 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.675 0 0 0 0 0.7125 0 0 0 0 0.75 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_4918_27537"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_4918_27537",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_4918_27537",
				x1: 77.0251,
				y1: 116.575,
				x2: 83.997,
				y2: 88.8642,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .0820223,
						stopColor: "#F09337"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .506944,
						stopColor: "#F09337",
						stopOpacity: .537111
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#F09337",
						stopOpacity: 0
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_4918_27537",
				x1: 90.2009,
				y1: 91.4602,
				x2: 90.2009,
				y2: 98.2736,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFCC00" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F7B54A"
				})]
			})
		] })
	]
});
export default SvgSendIntraAccount;
